import React, { ChangeEvent, FC, useState } from 'react';
import { ModalBody, ModalCancelBtn, ModalCloseBtn, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { logger } from '@fiverr-private/obs';
import { raiseToast } from '@fiverr-private/toast';
import { SEND_REQUEST_TRANSLATION_KEY, TRANSLATION_KEY } from '../constants';
import { AdminInfo } from '../AdminInfo';
import { RequestTextControl } from '../RequestTextControl';
import { requestTemplateUpload } from '../../../api';
import { reportEventsApi } from '../../../biEvents';
import { ISendRequestStepContentProps } from './types';

export const SendRequestStep: FC<ISendRequestStepContentProps> = ({ adminInfo, biData, onNextStep }) => {
    const [requestText, setRequestText] = useState<string>('');
    const [isSubmitting, setSubmitting] = useState(false);

    const handleSendRequest = async (): Promise<void> => {
        try {
            setSubmitting(true);
            if (!adminInfo?.userId) {
                logger.error({ message: 'Failed to send upload document request: missing admin info' });
                return;
            }

            reportEventsApi.requestUploadDocument(biData);

            await requestTemplateUpload(adminInfo.userId, requestText);
            onNextStep();
        } catch (e) {
            raiseToast({ message: translate(`${TRANSLATION_KEY}.error_message`), type: 'error' });
        } finally {
            setSubmitting(false);
        }
    };

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
        setRequestText(event.target.value);
    };

    return (
        <>
            <ModalHeader>
                <I18n k={`${SEND_REQUEST_TRANSLATION_KEY}.title`} />
                <ModalCloseBtn />
            </ModalHeader>
            <ModalBody>
                <Stack direction="column" gap="6">
                    <Text>
                        <I18n k={`${SEND_REQUEST_TRANSLATION_KEY}.description`} />
                    </Text>
                    <AdminInfo adminInfo={adminInfo} />
                    <RequestTextControl requestText={requestText} onChange={handleChange} />
                </Stack>
            </ModalBody>
            <ModalFooter>
                <ModalCancelBtn />
                <Button
                    onClick={handleSendRequest}
                    disabled={!adminInfo || isSubmitting}
                    loading={!adminInfo || isSubmitting}
                >
                    <I18n k={`${SEND_REQUEST_TRANSLATION_KEY}.submit`} />
                </Button>
            </ModalFooter>
        </>
    );
};
